import emojis from '../data/emojis'

import { DataEmojis } from './DataTypes'

export const allEmojis: DataEmojis = Object.values(emojis).flat()
